/* Product page helpers: "Get it" panel store line + sticky add-to-cart bar (mobile). */
(() => {
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  function fillGetIt() {
    const box = document.querySelector('[data-sf-getit]');
    if (!box) return;
    const w = window.spartanStoreWidgetInstance;
    let s = w && w.currentStore;
    const only = box.dataset.sfPickupOnly;
    if (only !== undefined) {
      // Pickup-only item: call the store that has it, not the customer's store
      s = null;
      const words = only.toLowerCase().split(/[^a-z]+/).filter((x) => x.length > 3);
      try {
        const list = JSON.parse(document.getElementById('SpartanMetaobjectStoresData').textContent);
        s = list.find((st) => words.some((x) => ((st.city || '') + ' ' + (st.name || '')).toLowerCase().includes(x))) || null;
      } catch (e) {}
    }
    if (box.hasAttribute('data-sf-on-only')) {
      // Ontario-only item: only offer the customer's store when it is in Ontario
      const inOn = s && /^(on|ontario)$/i.test(String(s.province || '').trim());
      if (inOn) box.querySelector('[data-sf-on-title]').textContent = 'Free pickup at Spartan Fitness ' + String(s.city).trim() + ' (Ontario only)';
      else s = null;
    }
    const limitedTo = box.dataset.sfStoreLimited;
    if (limitedTo !== undefined) {
      // Named-stores item: the buy button only shows (CSS, .is-allowed) at one of those stores
      const pricing = window.SpartanStorePricing;
      const allowed = !!(s && pricing && limitedTo.split('|').some((city) => pricing.scoreValue(city, s) === 3));
      box.classList.toggle('is-allowed', allowed);
      const cities = limitedTo.split('|').join(', ');
      const where = s && s.city ? String(s.city).trim() : '';
      box.querySelector('[data-sf-limited-title]').textContent = allowed ? 'Available at your ' + where + ' store' : 'Only available at select stores';
      box.querySelector('[data-sf-limited-text]').textContent = allowed
        ? 'Sold only at ' + cities + '.'
        : 'Available only at ' + cities + '.' + (where ? ' Not available from your ' + where + ' store.' : ' Choose your store to check.');
      if (!allowed) s = null;
    }
    const name = box.querySelector('[data-sf-getit-store]');
    if (s && s.city) {
      if (name) name.textContent = 'at Spartan Fitness ' + String(s.city).trim();
      const call = box.querySelector('[data-sf-getit-call]');
      if (s.phone && call) {
        const a = call.querySelector('[data-sf-getit-phone]');
        a.textContent = s.phone;
        a.href = 'tel:' + String(s.phone).replace(/[^\d+]/g, '');
        call.hidden = false;
      }
    }
  }

  function wireChange() {
    const btn = document.querySelector('[data-sf-getit-change]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const w = window.spartanStoreWidgetInstance;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        if (w && w.openDropdown) w.openDropdown();
        else document.querySelector('.spartan-nearest-store-trigger')?.click();
      }, 250);
    });
  }

  function stickyBar() {
    const add = document.querySelector('buy-buttons button[name="add"]');
    const bar = document.querySelector('[data-sf-stickybuy]');
    if (!add || !bar || !('IntersectionObserver' in window)) return;
    document.body.appendChild(bar); // escape the product column so it sits above the whole page
    bar.querySelector('[data-sf-stickybuy-btn]').addEventListener('click', () => {
      if (add.disabled) { add.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      add.click();
    });
    new IntersectionObserver(([e]) => {
      const past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }).observe(add);
    // Keep the bar's price in step with the selected variant
    const price = document.querySelector('.price-container .price__current');
    const out = bar.querySelector('[data-sf-stickybuy-price]');
    if (price && out) new MutationObserver(() => { out.textContent = price.textContent.trim(); }).observe(price, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    fillGetIt();
    wireChange();
    stickyBar();
    // The header widget finds the store after load; refill when it does
    let tries = 0;
    const t = setInterval(() => { fillGetIt(); if (++tries > 20 || (window.spartanStoreWidgetInstance && window.spartanStoreWidgetInstance.currentStore)) clearInterval(t); }, 500);
  }
  document.addEventListener('spartan:store_changed', fillGetIt);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
